export default "__VITE_ASSET__CkWX1iY9__"